"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extDivClass = zebra.Class(zebra.ui.Panel, [
    function (handler, getInput) {
        this.$super();
        this.isPopupEditor = true;
        this._handler = handler;
        this._getInput = getInput;
        this._accepted = false;
        this._result = undefined;
        this._error = null;
    },
    function getResult() {
        return this._result;
    },
    function getError() {
        return this._error;
    },
    function isAccepted() {
        return this._accepted;
    },
    function setParent(o) {
        var _this = this;
        this.$super.call(this, o);
        if (o !== null) {
            this._handler(this._getInput)
                .then(function (response) {
                if (response.error) {
                    _this._error = response.error;
                }
                else if (response.accepted) {
                    _this._accepted = true;
                    _this._result = response.data;
                }
                else {
                }
                _this.removeMe();
            })
                .catch(function (error) {
                _this._error = error;
            });
        }
    }
]);
//# sourceMappingURL=ExtDiv.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/popups/ExtDiv.js
// module id = 25
// module chunks = 0